<template>
  <div>
    <div v-if="field.label">
      <label :for="field.name">{{ field.label }}</label>
    </div>
    <div>
      <input
        type="file"
        :name="field.name"
        :id="field.name"
        @change="onFileChange"
        :accept="field.accept"
        multiple
      />
    </div>
    <div v-if="field.help_text">
      <small>{{ field.help_text }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  methods: {
    onFileChange(event) {
      this.$parent.updateValue(this.field.key, event.target.files);
      this.$parent.addUploadFile(this.field.key, event.target.files);
    }
  }
};
</script>
